class ToggleButtonGroup {
    constructor(buttonGroup) {
        this.$buttonGroup = $(buttonGroup);
        this.$input = $(`input[name="${buttonGroup.dataset.toggleButtons}"]`, this.$buttonGroup);
        this.$buttons = $('button[data-filter-by]', this.$buttonGroup);

        this.onInputChange = this.onInputChange.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);

        this.init();
    }

    init() {
        this.update();
        this.bindEvents();
    }

    bindEvents() {
        this.$buttonGroup.on('change', 'input', this.onInputChange);
        this.$buttonGroup.on('click', 'button', this.onButtonClick);
        $(document).on('updateToggleButtonInstances', this.onInputChange);
    }

    onInputChange() {
        this.update();
    }

    onButtonClick(event) {
        const target = event.currentTarget;
        const unique = target.hasAttribute('data-filter-unique');
        const filterBy = target.dataset.filterBy;
        let values = this.$input.prop('values');

        if (unique) values = [];

        if (filterBy) {
            const existing = values.indexOf(filterBy);
            if (existing > -1) values.splice(existing, 1);
            else values.push(filterBy);
        }

        this.$input.val(values.join(', '));
        this.$input.trigger('change');
    }

    update() {
        this.$input.prop('values', this.getInputValue());
        this.updateButtonStates();
    }

    getInputValue() {
        const value = this.$input.val();
        return value && value.split(', ') || [];
    }

    updateButtonStates() {
        const values = this.$input.prop('values');

        this.$buttons.each((i, button) => {
            const $button = $(button);
            const filterBy = button.dataset.filterBy;
            const allButton = filterBy === '';
            const existing = values.indexOf(filterBy) !== -1;

            $button.toggleClass('checked is-active', existing || allButton && !values.length);
        });
    }
}

export default () => {
    const buttonGroups = [];
    $('[data-toggle-buttons]').each((i, item) => {
        const buttonGroupInstance = new ToggleButtonGroup(item);
        buttonGroups.push(buttonGroupInstance);
    });
    return buttonGroups;
};
